__turbopack_context__.v({
  "className": "poppins_e31c19d4-module__pynubq__className",
  "variable": "poppins_e31c19d4-module__pynubq__variable",
});
